import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { saveSession, getSession, clearAsyncStorage, USER_ID, EMAIL as EMAIL_KEY, FIRST_NAME, LAST_NAME, IS_IMPERSONATED } from "./common/LocalStorage";
import { WALLETBALANCE } from "./common/webUtils";
import LoginScreen from "./components/LoginScreen";
import DashBoardScreen from "./components/DashboardScreen";
import RegisterScreen from "./components/RegisterScreen";
import OtpScreen from "./components/OtpScreen";
import ProductListScreen from "./components/ProductListScreen";
import ProductDetailsScreen from "./components/ProductDetailsScreen";
import UpdateUserInfoScreen from "./components/UpdateUserInfoScreen";
import OrderListScreen from "./components/OrderListScreen";
import CartScreen from "./components/CartScreen";
import MyAccountScreen from "./components/MyAccountScreen";
import ShippingAddressScreen from "./components/ShippingAddressScreen";
import AddShippingAddressScreen from "./components/AddShippingAddressScreen";
import SubscribeListScreen from "./components/SubscribeListScreen";
import CheckoutScreen from "./components/CheckoutScreen";
import ForgotPasswordScreen from "./components/ForgotPasswordScreen";
import ChangePasswordScreen from "./components/ChangePasswordScreen";
import CommonScreen from "./components/CommonScreen";
import FaqScreen from "./components/FaqScreen";
import StoriesScreen from "./components/StoriesScreen";
import WalletScreen from "./components/WalletScreen";
import ThankyouScreen from "./components/ThankyouScreen";
import CancelSubscriptionListScreen from "./components/CancelSubscriptionListScreen";
import ContactScreen from "./components/ContactScreen";
import InquiryScreen from "./components/InquiryScreen";
import LogSubscriptionListScreen from "./components/LogSubscriptionListScreen";
import { withNavigation } from './common/routerShim';
const DashBoard = withNavigation(DashBoardScreen);
const Login = withNavigation(LoginScreen);
const Register = withNavigation(RegisterScreen);
const Otp = withNavigation(OtpScreen);
const ProductList = withNavigation(ProductListScreen);
const ProductDetails = withNavigation(ProductDetailsScreen);
const UpdateUserInfo = withNavigation(UpdateUserInfoScreen);
const OrderList = withNavigation(OrderListScreen);
const Cart = withNavigation(CartScreen);
const MyAccount = withNavigation(MyAccountScreen);
const ShippingAddress = withNavigation(ShippingAddressScreen);
const AddShippingAddress = withNavigation(AddShippingAddressScreen);
const SubscribeList = withNavigation(SubscribeListScreen);
const Checkout = withNavigation(CheckoutScreen);
const Faq = withNavigation(FaqScreen);
const Stories = withNavigation(StoriesScreen);
const Common = withNavigation(CommonScreen);
const Contact = withNavigation(ContactScreen);
const Inquiry = withNavigation(InquiryScreen);
const Wallet = withNavigation(WalletScreen);
const Thankyou = withNavigation(ThankyouScreen);
const CancelSubscriptionList = withNavigation(CancelSubscriptionListScreen);
const LogSubscriptionList = withNavigation(LogSubscriptionListScreen);
const ChangePassword = withNavigation(ChangePasswordScreen);
const ForgotPassword = withNavigation(ForgotPasswordScreen);

function App() {
  const [ready, setReady] = useState(false);
  const [isImpersonated, setIsImpersonated] = useState(false);

  useEffect(() => {
    const handleImpersonationParams = async () => {
      const params = new URLSearchParams(window.location.search);
      if (params.get('is_impersonated') === '1') {
        // Clear stale data from any previous session/impersonation
        await clearAsyncStorage();

        // Save impersonation customer data to AsyncStorage
        const customerId = params.get('customer_id');
        const email = params.get('email');
        const firstname = params.get('firstname');
        const lastname = params.get('lastname');

        if (customerId) await saveSession(USER_ID, customerId);
        if (email) await saveSession(EMAIL_KEY, email);
        if (firstname) await saveSession(FIRST_NAME, firstname);
        if (lastname) await saveSession(LAST_NAME, lastname);
        await saveSession(IS_IMPERSONATED, "1");
        setIsImpersonated(true);

        // Clean impersonation params from URL
        params.delete('is_impersonated');
        params.delete('customer_id');
        params.delete('email');
        params.delete('firstname');
        params.delete('lastname');

        const cleanUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
        window.history.replaceState({}, '', cleanUrl);
      } else {
        // Check AsyncStorage for existing impersonation state
        const impersonated = await getSession(IS_IMPERSONATED);
        if (impersonated === "1") {
          // Verify with server — stale AsyncStorage can persist after impersonation ends
          try {
            const userId = await getSession(USER_ID);
            if (userId) {
              const res = await fetch(WALLETBALANCE + userId);
              const json = await res.json();
              if (json.is_impersonated) {
                setIsImpersonated(true);
              } else {
                // Server says not impersonated — clear stale flag
                await saveSession(IS_IMPERSONATED, "0");
              }
            } else {
              await saveSession(IS_IMPERSONATED, "0");
            }
          } catch (e) {
            // On error, clear stale flag to avoid stuck impersonation
            await saveSession(IS_IMPERSONATED, "0");
          }
        }
      }
      setReady(true);
    };
    handleImpersonationParams();
  }, []);

  if (!ready) return null;

  // During impersonation, only allow subscription and wallet screens
  const imp = isImpersonated;
  const redirectToSubs = <Navigate to="/subscriptionlist-screen" replace />;

  return (
    <div className="App">
      {/* <script src="https://maps.googleapis.com/maps/api/js?key=<INSERT-API-KEY-HERE>&libraries=places&callback=initMap"async></script> */}

      {/* <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header> */}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={imp ? redirectToSubs : <Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={imp ? redirectToSubs : <DashBoard />} />
          <Route path="/login-screen" element={imp ? redirectToSubs : <Login />} />
          <Route path="/register-screen/:paramRefercode" element={imp ? redirectToSubs : <Register />} />
          <Route path="/register-screen" element={imp ? redirectToSubs : <Register />} />
          <Route path="/otp-screen" element={imp ? redirectToSubs : <Otp />} />
          <Route path="/products-screen" element={imp ? redirectToSubs : <ProductList />} />
          <Route path="/product-details-screen/:paramId/:isWallet" element={imp ? redirectToSubs : <ProductDetails />} />
          <Route path="/update-user-info" element={imp ? redirectToSubs : <UpdateUserInfo />} />
          <Route path="/orders" element={imp ? redirectToSubs : <OrderList />} />
          <Route path="/cart-screen" element={imp ? redirectToSubs : <Cart />} />
          <Route path="/my-account" element={imp ? redirectToSubs : <MyAccount />} />
          <Route path="/shipping-address" element={imp ? redirectToSubs : <ShippingAddress />} />
          <Route path="/add-shipping-address" element={imp ? redirectToSubs : <AddShippingAddress />} />
          <Route path="/subscriptionlist-screen" element={<SubscribeList />} />
          <Route path="/checkout" element={imp ? redirectToSubs : <Checkout />} />
          <Route path="/faq" element={imp ? redirectToSubs : <Faq />} />
          <Route path="/stories" element={imp ? redirectToSubs : <Stories />} />
          <Route path="/common/:paramInfoId" element={imp ? redirectToSubs : <Common />} />
          <Route path="/contact-screen" element={imp ? redirectToSubs : <Contact />} />
          <Route path="/inquiry-screen" element={imp ? redirectToSubs : <Inquiry />} />
          <Route path="/wallet-screen" element={<Wallet />} />
          <Route path="/thank-you" element={imp ? redirectToSubs : <Thankyou />} />
          <Route path="/cancelled-subscriptions" element={<CancelSubscriptionList />} />
          <Route path="/subscription-logs" element={<LogSubscriptionList />} />
          <Route path="/change-password" element={imp ? redirectToSubs : <ChangePassword />} />
          <Route path="/forgot-password" element={imp ? redirectToSubs : <ForgotPassword />} />
          <Route path="*" element={imp ? redirectToSubs : <Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
